import { SECTIONS } from "./sections.js";
import { staticSidebarItems } from "./static-items.js";
import * as boardModules from "./index.js";

/**
 * Genera el array menuItems para SideBarItems.js a partir de:
 * - Los manifests de todos los boards en src/boards/index.js
 * - Los staticSidebarItems (rutas no-board)
 * - La metadata de secciones en sections.js
 *
 * Reglas de orden:
 * 1. Items top-level ordenados por sidebar.order (ascendente)
 * 2. Grupos (CSM, COMERCIAL) aparecen después, ordenados por groups[name].order
 */
export function generateSidebar() {
  // Recopilar todos los items (board manifests + static)
  const boardItems = Object.values(boardModules)
    .filter((m) => m.sidebar && m.enabled !== false)
    .map((m) => ({ ...m.sidebar, path: m.path }));

  const allItems = [...boardItems, ...staticSidebarItems];

  return SECTIONS.map((section) => {
    const sectionItems = allItems
      .filter((item) => item.section === section.name)
      .sort((a, b) => a.order - b.order);

    // Separar top-level de agrupados
    const topLevel = sectionItems
      .filter((item) => !item.group)
      .map((item) => ({ title: item.title, to: item.path, roles: item.roles }));

    const groupMap = new Map();
    for (const item of sectionItems.filter((i) => i.group)) {
      if (!groupMap.has(item.group)) {
        const groupConfig = section.groups?.[item.group] ?? {};
        groupMap.set(item.group, {
          order: groupConfig.order ?? 999,
          entry: {
            title: item.group,
            roles: groupConfig.roles ?? section.roles,
            subtitle: [],
          },
        });
      }
      groupMap.get(item.group).entry.subtitle.push({
        subTitle: item.title,
        to: item.path,
        roles: item.roles,
      });
    }

    const groups = [...groupMap.values()]
      .sort((a, b) => a.order - b.order)
      .map((g) => g.entry);

    return {
      name: section.name,
      roles: section.roles,
      item: [...topLevel, ...groups],
    };
  });
}
